// extracted by mini-css-extract-plugin
export default {"SkeletonShipmentTab":"SkeletonShipmentTab_SkeletonShipmentTab__KC--m","LeftItem":"SkeletonShipmentTab_LeftItem__j9lQT","RightItem":"SkeletonShipmentTab_RightItem__zuthk"};